module.exports = __webpack_public_path__ + "static/media/文本情感分析).6480ca45.png";